import {
  getDoctorInsuranceFromBiko,
  type BikoPublicInsuranceData,
} from '@/common/apis/services/biko/getDoctorInsurance';

export type { BikoPublicInsuranceData };

export const PROFILE_BIKO_INSURANCE_QUERY_KEY = 'profileBikoInsurance';

export async function fetchDoctorBikoInsurance(
  userId: string | number | null | undefined,
): Promise<BikoPublicInsuranceData | null> {
  if (userId == null || userId === '') return null;
  return getDoctorInsuranceFromBiko(userId);
}
